import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=86449fde&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=86449fde&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86449fde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86449fde')) {
      api.createRecord('86449fde', component.options)
    } else {
      api.reload('86449fde', component.options)
    }
    module.hot.accept("./Collection.vue?vue&type=template&id=86449fde&scoped=true", function () {
      api.rerender('86449fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/SettleFlod/Child/Collection.vue"
export default component.exports